import React, { useRef, useEffect, useState } from "react";
import QRCode from "qrcode"; // Librería para generar QR
import Button from "@material-ui/core/Button";
import GetAppIcon from "@material-ui/icons/GetApp";

const QRWithBackground = ({
  qrValue,
  backgroundImage,
  qrSize = 200,
  fileName = "QR-Dashport.png",
}) => {
  const canvasRef = useRef(null);
  // En mobile el long-press para "guardar imagen" sobre un <canvas> no
  // siempre funciona (y no funciona nunca si el canvas queda tainted por
  // CORS), así que se ofrece un botón explícito que fuerza la descarga.
  const [listoParaDescargar, setListoParaDescargar] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    setListoParaDescargar(false);

    const image = new Image();
    image.src = backgroundImage;
    image.crossOrigin = "anonymous"; // Evita problemas de CORS

    image.onload = () => {
      canvas.width = image.width;
      canvas.height = image.height;
      ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

      // Generar QR como imagen base64 con color rojo
      QRCode.toDataURL(qrValue, {
        width: qrSize,
        margin: 1,
        color: {
          dark: "#ef4123", // Rojo
          light: "#ffffff", // Blanco de fondo
        },
      })
        .then((qrUrl) => {
          const qrImage = new Image();
          qrImage.src = qrUrl;
          qrImage.onload = () => {
            const posX = (canvas.width - qrSize) / 2;
            const posY = (canvas.height - qrSize) / 2 - 70;
            ctx.drawImage(qrImage, posX, posY, qrSize, qrSize);
            setListoParaDescargar(true);
          };
        })
        .catch((err) => console.error("Error generando QR:", err));
    };
  }, [qrValue, backgroundImage, qrSize]);

  function handleDescargar() {
    const canvas = canvasRef.current;
    try {
      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      console.error("Error descargando el QR:", err);
    }
  }

  return (
    <div style={{ textAlign: "center" }}>
      <canvas ref={canvasRef} style={{ maxWidth: "100%" }} />
      <div>
        <Button
          variant="contained"
          color="primary"
          startIcon={<GetAppIcon />}
          disabled={!listoParaDescargar}
          onClick={handleDescargar}
          style={{ marginTop: 10 }}
        >
          Descargar QR
        </Button>
      </div>
    </div>
  );
};

export default QRWithBackground;
